import { render, staticRenderFns } from "./FinalGroceryList.vue?vue&type=template&id=3291ca77&"
import script from "./FinalGroceryList.vue?vue&type=script&lang=js&"
export * from "./FinalGroceryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports